import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectEmailApprovalState = (state) => state.emailApproval || initialState;

export const selectUserApproval = createSelector(
  [selectEmailApprovalState],
  (state) => state.userApproval
);

export const selectUserAction = createSelector(
  [selectEmailApprovalState],
  (state) => state.userAction
);
